import { type FC } from 'react';

import { ChipsOption } from 'shared/models/ChipsOption';
import { SliderBlockTypeOneSlideService } from 'shared/services/ChipsDataService';

import { SliderBlockTypeOne } from './SliderBlockTypeOne';
import { SliderBlockTypeOneModel } from './external/models/SliderBlockTypeOneModel';
import { SliderBlockTypeOneSlideModel } from './internal/models/SliderBlockTypeOneSlideModel';

const sliderBlockTypeOneSlideService = new SliderBlockTypeOneSlideService([
  new SliderBlockTypeOneModel(new ChipsOption('Отделка'), [
    new SliderBlockTypeOneSlideModel(
      'Готовая отделка',
      'Квартиры с отделкой готовы к заселению сразу после получения ключей. Новым жителям достаточно только завезти мебель.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/finishing/finished-finish.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Предчистовая отделка',
      'Квартира полностью готова к финальному ремонту: вам останется только выбрать цвета и материалы для чистовой отделки',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/finishing/pre-finishing.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Без отделки',
      'Формат, который предоставляет полную свободу выбора в ремонте: от перегородок до покрытий и сантехники',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/finishing/without-finishing.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Умные системы'), [
    new SliderBlockTypeOneSlideModel(
      'IP-домофоны с FaceID',
      'IP-домофоны с системой FaceID обеспечивают удобство и безопасность в реальном времени. Жители могут управлять входом в подъезд и к лифтам через смартфон, что исключает присутствие посторонних.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-systems/ip-intercoms-with-faceID.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Автоматический сбор данных',
      'Благодаря автоматическим счётчикам воды, света и тепла — больше не нужно передавать данные вручную',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-systems/automatic-data-collection.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Видеокамеры',
      'Круглосуточное видеонаблюдение за дворами, подъездами и парковками обеспечивает безопасность наших кварталов',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-systems/video-cameras.jpg',
    ),
  ]),
  new SliderBlockTypeOneModel(new ChipsOption('Умные планировки'), [
    new SliderBlockTypeOneSlideModel(
      'Мастер-спальня',
      'Мастер-спальня — это пространство, где, помимо спальной комнаты, есть отдельная ванная и место под отдельную гардеробную. Такая планировка помогает сохранить личное пространство даже в большой семье.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-layouts/master-bedroom.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Кухня-гостиная',
      'Гостиные в квартирах ПИК — это продуманные пространства, где комфортно работать, делать уроки, отдыхать и принимать гостей',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-layouts/kitchen-living-room.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Гардеробная',
      'Компактное многофункциональное пространство, в котором можно оборудовать гардероб, уютный кабинет, маленькую детскую или даже мини-спортзал',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-layouts/wardrobe.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Постирочная',
      'Удобное пространство, где можно разместить стиральную машину, хранить средства для стирки, сушить и гладить одежду',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-layouts/laundry.jpg',
    ),
    new SliderBlockTypeOneSlideModel(
      'Сквозной санузел',
      'Ванные комнаты с несколькими входами. В них можно попасть из спальни или из прихожей.',
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/product-features-of-the-quarters/smart-layouts/pass-through-bathroom.jpg',
    ),
  ]),
]);

export const ProductFeaturesOfTheQuarters: FC = () => {
  return (
    <SliderBlockTypeOne
      description="Больше чем квартиры"
      id="product-features-of-the-quarters"
      sliderBlockTypeOneSlideService={sliderBlockTypeOneSlideService}
      title="Продуктовые особенности кварталов"
    />
  );
};
